import React from 'react';
import { TextField } from '@datanomik/commons-ui';
import { AutocompleteRenderInputParams } from '@mui/material';

interface AccountAutocompleteInputProps {
  params: AutocompleteRenderInputParams;
  label?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  autoFocus?: boolean;
}

export const AccountAutocompleteInput: React.FC<AccountAutocompleteInputProps> = ({
  params,
  label,
  placeholder,
  error,
  helperText,
  autoFocus,
}) => {
  return (
    <TextField

      {...params as any}
      label={label}
      placeholder={placeholder}
      error={error}
      helperText={helperText}
      autoFocus={autoFocus}
      fullWidth
      sx={{
        '& .MuiOutlinedInput-root': {
          paddingRight: '9px !important', // Adjust padding for end adornment
        },
      }}
    />
  );
};
